export function ValidationErrorList({ errors }: { errors: string[] }) {
  return (
    <div
      className="pipeline-validation-errors"
      data-testid="pipeline-validation-errors"
    >
      {errors.map((err, i) => (
        <div key={i} className="pipeline-validation-error">
          <span className="validation-error-bullet">•</span>
          <span className="validation-error-text">{err}</span>
        </div>
      ))}
    </div>
  );
}
